import { render, staticRenderFns } from "./ModalSelectCertType.vue?vue&type=template&id=642b35b2&scoped=true"
import script from "./ModalSelectCertType.vue?vue&type=script&lang=js"
export * from "./ModalSelectCertType.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectCertType.vue?vue&type=style&index=0&id=642b35b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b35b2",
  null
  
)

export default component.exports